import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import {
  CaseBattleAnimationEnum,
  CaseBattlesSlotsVariants,
  ICaseBattle,
  ICaseBattlePlayer,
} from '../interfaces/case-battles.interface';
import { CbIconComponent } from '../cb-icon/cb-icon.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { ContextMenuService } from '@core/services/context-menu.service';
import { fadeInOutAnimation } from '@core/utils/animations.util';
import { NgpTooltip, NgpTooltipTrigger } from 'ng-primitives/tooltip';
import { PlayerRowComponent } from '../../../core/components/player-row/player-row.component';

@Component({
  selector: 'app-cb-list-mode',
  templateUrl: './cb-list-mode.component.html',
  styleUrls: ['./cb-list-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  animations: [fadeInOutAnimation],
  imports: [
    CbIconComponent,
    SvgIconComponent,
    NgpTooltip,
    NgpTooltipTrigger,
    PlayerRowComponent,
  ],
  host: {
    '[style.--height]': 'uiSettings()?.height ?? "66px"',
  },
})
export class CbListModeComponent {
  readonly game = input.required<ICaseBattle>();
  animation = input<keyof typeof CaseBattleAnimationEnum | null>(null);
  uiSettings = input<{
    hideHeader?: boolean;
    height?: string;
  }>();

  playersArray = computed<(ICaseBattlePlayer | null)[]>(() =>
    Array.from(
      { length: this.game().max_participants },
      (_, index) => this.game().participants[index] ?? null
    ).sort((a, b) => {
      if (a === null) return 1;
      if (b === null) return -1;
      return a.slot - b.slot;
    })
  );
  winnerSlots = computed<CaseBattlesSlotsVariants[]>(() =>
    this.game().winners.map((winner) => winner.slot)
  );

  contextMenuService = inject(ContextMenuService);
}
